// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2517fe61","849":"dd42d3fb","879":"a239b903","977":"91abf689"}[chunkId] + ".chunk.js";
};